import {
  ChangeDetectionStrategy,
  Component,
  inject,
  model,
  signal,
} from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Component({
  selector: 'acl-vat',
  standalone: false,
  templateUrl: './vat.component.html',
  styleUrl: './vat.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VatComponent implements ControlValueAccessor {
  private readonly ngControl = inject(NgControl, {
    self: true,
    optional: true,
  });

  readonly isDisabled = model<boolean>(false);

  readonly value = signal<string | null>(null);

  constructor() {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }
  writeValue(obj: any): void {
    this.value.set(obj);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled.set(isDisabled);
  }

  onChange(val: any): void {
    console.error(val);
  }
  onTouched(val: any): void {
    console.error(val);
  }
}
